/**
 * NestJS(v2) API로 마이그레이션된 GraphQL operation 목록
 *
 * 이 목록에 포함된 operation은 v2 endpoint(`${API_HOST_V2}/gql`)로 라우팅되고
 * `x-api-version: '2'` 헤더가 추가됩니다.
 *
 * ⚠️ 이 Set은 자동 수집이 아닌 **수동 관리** 목록입니다.
 * 새로운 query/mutation을 v2로 마이그레이션할 때마다 operationName을
 * 직접 추가해야 하며, 누락 시 v1 endpoint로 잘못 라우팅됩니다.
 * (추가 절차는 `docs/260408-operation-list.md` 참고)
 */
export const V2_OPERATIONS = new Set<string>([
  'GetRateplanListSimple',
  'GetAdminPartnerInquiries',
  'GetAdminPartnerInquiry',
  'GetAdminPropertyList',
  'GetHistoryList',
  'GetHistoryListByApplyDate',
  'ResolveAuditUserNames',
]);

/**
 * 주어진 operation이 v2 API를 사용하는지 확인
 */
export const isV2Operation = (operationName: string | undefined): boolean =>
  operationName ? V2_OPERATIONS.has(operationName) : false;
